import { render, staticRenderFns } from "./BidPaperwork.vue?vue&type=template&id=26256830&"
import script from "./BidPaperwork.vue?vue&type=script&lang=js&"
export * from "./BidPaperwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports